'use client';
import React from 'react';
import { useParams } from 'next/navigation';
import Breadcumbs from '@/components/Breadcumbs';
import { TiArrowForward } from 'react-icons/ti';
import { IoArrowRedoCircle } from 'react-icons/io5';
import { TbPointFilled } from 'react-icons/tb';
import neuroscience from '@/data/neuroscience';
import { notFound } from 'next/navigation';

const Department = () => {
  const { slug } = useParams();

  const filteredData = [
    ...neuroscience.Orthopaedics || [],
    ...neuroscience.InternalMedicine || [],
    ...neuroscience.Pediatrics || [],
    ...neuroscience.Endocrinology || [],
  ];

  const data = filteredData.find(item => item?.slug?.split('/').pop() === slug);

  if (!data) {
    notFound();
  }

  return (
    <div>
      <Breadcumbs
        title={data.breadcumbtitle}
        items={[{ label: 'Home', href: '/' },
        { label: "Our Centers of Excellence" },
        { label: data.breadcumbtitle }]}
      />
      <div className="ctvs-section css-padding">
        <div className="container">
          {/* title */}
          <div className="row">
            <h2 className="css-fs-15 css-dept-margin text-justify">{data.description}</h2>
          </div>

          {/* two column */}
          <div className="row g-4">
            <div className="col-md-12 col-xl-6">
              {data.heading && <p className="css-sub-heading">{data.heading}</p>}
              {data.points && (
                <ul className="list-unstyled">
                  {data.points.map((item, i) => (
                    <li className="css-margin-ctvs-bottom d-flex" key={i}>
                      <div className="me-2 css-arrow-renal"><TiArrowForward /></div>
                      <div className={`css-pointdescription ${item.point === 'Conditions We Treat: Including but not limited to' ? 'special-treatment-list' : ''}`}>
                        {item.point && <strong>{item.point}:</strong>}{' '}
                        {Array.isArray(item.pointdescription) ? (
                          <ul className="mt-2">
                            {item.pointdescription.map((desc, j) => (
                              <li key={j} className="d-flex align-items-start gap-2 mb-2">
                                <TbPointFilled className="mt-1" />
                                <span>{desc}</span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          item.pointdescription
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
              {data.heading3 && <p className="css-sub-heading mt-4">{data.heading3}</p>}
              {data.points3 && (
                <ul className="list-unstyled">
                  {data.points3.map((item, i) => (
                    <li key={`p3-${i}`} className="css-margin-ctvs-bottom d-flex">
                      <div className="me-2 css-arrow-renal"><TiArrowForward /></div>
                      <div className="css-pointdescription">
                        {item.point && <strong>{item.point}:</strong>} {item.pointdescription}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="col-md-12 col-xl-6">
              {data.heading2 && <p className="css-sub-heading">{data.heading2}</p>}
              {data.points2 && (
                <ul className="list-unstyled">
                  {data.points2.map((item, i) => (
                    <li key={`p2-${i}`} className="css-margin-ctvs-bottom d-flex">
                      <div className="me-2 css-arrow-renal"><TiArrowForward /></div>
                      <div className="css-pointdescription">
                        {item.point && <strong>{item.point}:</strong>} {item.pointdescription}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
              {data.moreinfo && (
                <p className="fw-bold mt-2 d-flex">
                  <IoArrowRedoCircle className="me-2 css-arrow-renal css-circle-arrow" />
                  {data.moreinfo}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Department;
